module.exports = __webpack_public_path__ + "img/img-chart-01.337faadb.png";